(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-ln-rail-controls]').forEach(controls => {
    const rail = document.getElementById(controls.dataset.lnRailControls);
    if (!rail) return;
    const previous = controls.querySelector('[data-ln-rail-prev]');
    const next = controls.querySelector('[data-ln-rail-next]');
    const update = () => {
      const overflow = rail.scrollWidth - rail.clientWidth;
      controls.hidden = overflow < 4;
      previous.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft >= overflow - 4;
    };
    const move = direction => {
      const card = rail.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0) : rail.clientWidth;
      rail.scrollBy({left: direction * step, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, {passive:true});
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
    });
    new ResizeObserver(update).observe(rail);
    update();
  });

  function openSophi() {
    const trigger = document.querySelector('#sophi-widget .sophi-tab');
    if (trigger) {
      if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    } else location.assign('https://designer.lumirafurn.com/studio/en/world/?intent=sophi');
  }
  const dialog = document.querySelector('[data-ln-signin]');
  let pendingSophi = false;
  const dismissedKey = 'lumira-signin-dismissed-v1';
  const snoozeMs = 7 * 24 * 60 * 60 * 1000;
  let offeredThisPage = false;
  let readyForInvitation = false;
  const dismissedRecently = () => {
    try { return Date.now() - Number(localStorage.getItem(dismissedKey) || 0) < snoozeMs; }
    catch { return false; }
  };
  function showInvitation() {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (dialog.open) return true;
    // A sign-in invitation is not consent to persistent AI memory.
    // Do not change the existing, explicit Sophi memory preference.
    offeredThisPage = true;
    document.querySelectorAll('[data-ln-header] details[open]').forEach(item => { item.open = false; });
    dialog.showModal();
    return true;
  }
  if (dialog) {
    dialog.querySelectorAll('[data-ln-signin-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('cancel', () => { pendingSophi = false; });
    dialog.addEventListener('close', () => {
      try { localStorage.setItem(dismissedKey, String(Date.now())); } catch {}
      if (pendingSophi) { pendingSophi = false; openSophi(); }
    });
    document.querySelectorAll('[data-ln-account-trigger]').forEach(link => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (showInvitation()) event.preventDefault();
    }));
    const maybeInvite = () => {
      if (!readyForInvitation || offeredThisPage || dismissedRecently() || !document.querySelector('[data-ln-home-version]')) return;
      if (document.visibilityState !== 'visible' || document.querySelector('dialog[open], #sophi-widget.is-open, [data-ln-header] details[open]')) return;
      if (['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName)) return;
      // Let visitors experience the page before offering an account. No timed takeover on arrival.
      if (scrollY < Math.min(900, innerHeight * .9)) return;
      showInvitation();
    };
    setTimeout(() => { readyForInvitation = true; maybeInvite(); }, 20000);
    window.addEventListener('scroll', maybeInvite, {passive:true});
  }
  document.querySelectorAll('[data-ln-open-sophi]').forEach(button => button.addEventListener('click', () => {
    if (dialog && !dismissedRecently()) {
      pendingSophi = true;
      if (showInvitation()) return;
      pendingSophi = false;
    }
    openSophi();
  }));
})();
